import { withAuthenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { Amplify } from "aws-amplify";
import awsconfig from "./aws-exports";
import Admin from "./Admin";
import { Box } from "@mui/material";
import Header from "./Header";
import { useRef } from "react";

Amplify.configure(awsconfig);

const App = ({ signOut, user }) => {
  const loader = useRef(false);
  return (
    <Box display={"flex"} width={"100%"} flexDirection={"column"}>
      <Header signOut={signOut}></Header>
      <Admin loader={loader}></Admin>
    </Box>
  );
};

// Hide Signup Tab by configuring `withAuthenticator`
export default withAuthenticator(App, {
  hideSignUp: true, // Hides the Signup tab
});
